import { CustomPipeSeries } from "@src/core/api/customPipeSeries";
import { isNotNil } from "@src/shared/helpers/guards";
import { Pipe } from "./buildPipes";
import { PipeSeries } from "./buildPipeSeries";

export function normalizeCustomSeries(
  customSeries: CustomPipeSeries[],
): PipeSeries[] {
  return customSeries
    .filter((series) => series.pipes.length > 0)
    .map((series) => {
      const normalizedPipes = series.pipes.map(normalizeCustomPipe);
      const pipes =
        normalizedPipes.length === 1
          ? normalizedPipes
          : [
              {
                editable: false,
                id: "all",
                internalDiameter: -1,
                label: null,
                maxPressure: -1,
                maxTemperature: -1,
                roughness: -1,
                translationKey: "pipeSeries.allPipeSizes",
                valveSize: null,
              } satisfies Pipe,
              ...normalizedPipes,
            ];
      const defaultPipe = pipes[0];
      return {
        custom: true,
        default: false,
        defaultPipe,
        editable: true,
        id: series.id,
        name: series.name,
        pipes,
      } satisfies PipeSeries;
    })
    .filter(isNotNil);
}

function normalizeCustomPipe(pipe: CustomPipeSeries["pipes"][number]): Pipe {
  return {
    editable: true,
    id: pipe.id,
    internalDiameter: pipe.internalDiameter,
    label: pipe.name,
    maxPressure: pipe.maxPressure,
    maxTemperature: pipe.maxTemperature,
    roughness: pipe.roughness,
    translationKey: null,
    valveSize: null,
  };
}
